export enum Role {
    NONE = "",
    STUDENT = "Student",
    TEACHER = "Teacher",
    PARENT = "Parent"
  }
